import ScrollToItem from "../helper/scroll-to-item";
class DestinationTruncation {
    constructor(DOMelement, store) {
        try {
            const contentDescriptionDiv = DOMelement;
            this.lineClampLimit = 4;
            this.lineCountDifference = 0;
            const elementNodes = Array.from(contentDescriptionDiv.childNodes).filter(node => node.nodeType === Node.ELEMENT_NODE && node.tagName.toLowerCase() !== 'br');

            if (contentDescriptionDiv.className.includes("sd-read-more-content")) {
                var hasUnorderedList;
                if (contentDescriptionDiv.parentElement?.classList.contains('global__hero-content-details')) {
                    hasUnorderedList = elementNodes.some(node => node.tagName.toLowerCase() === 'ul');
                }

                if (hasUnorderedList) {
                    return 0;
                }
            }

            let totalLineCount = 0;
            let clampFromIndex = -1;
            let clampDepth = '';
            let lineCount = this.GetLineCount(elementNodes[0]);

            for (let i = 0; i < elementNodes.length; i++) {
                const node = elementNodes[i];
                if (node.tagName.toLowerCase() !== 'br') {
                    let templineCount = totalLineCount;
                    totalLineCount += this.GetLineCount(node);
                    clampFromIndex++;
                    if (totalLineCount >= this.lineClampLimit) {
                        this.lineCountDifference = this.lineClampLimit - templineCount;
                        clampDepth = this.lineCountDifference === 1 ? "-single" : (this.lineCountDifference === 2 ? "-double" : (this.lineCountDifference === 3 ? "-triple" : ""));
                        break;
                    }
                }
            }

            for (let i = 0; i < elementNodes.length; i++) {
                if (i > clampFromIndex) {
                    elementNodes[i].classList.add("item-hidden");
                }
                elementNodes[clampFromIndex].classList.add("clamped" + clampDepth);
            }

            const readMoreLink = document.createElement('a');
            readMoreLink.textContent = 'Read more';
            readMoreLink.className = 'read-more-link';
            contentDescriptionDiv.appendChild(readMoreLink);

            const hasMultipleItems = elementNodes.length > 1;
            readMoreLink.classList.toggle("read-more-hidden", lineCount <= this.lineClampLimit && (!hasMultipleItems || totalLineCount < this.lineClampLimit));

            let isExpanded = false;
            this.CheckListItemsCount(elementNodes[clampFromIndex], true);


            readMoreLink.addEventListener('click', (e) => {
                isExpanded = !isExpanded;

                for (let i = 0; i < elementNodes.length; i++) {
                    if (i > clampFromIndex) {
                        elementNodes[i].classList.toggle("item-hidden", !isExpanded);
                        elementNodes[i].classList.toggle("clamped" + clampDepth, isExpanded);
                    }
                }

                elementNodes[0].id = "firstElement";
                this.CheckListItemsCount(elementNodes[clampFromIndex], !isExpanded);
                new ScrollToItem(DOMelement, "#firstElement");

                elementNodes.forEach(item => item.classList.toggle('expanded'));
                readMoreLink.textContent = isExpanded ? 'Read less' : 'Read more';
            });
        } catch (error) {
            console.log(error);
        }
    }

    GetLineCount(itemDescription) {
        const computedStyle = window.getComputedStyle(itemDescription);
        const lineHeight = parseInt(computedStyle.lineHeight);
        const height = itemDescription.clientHeight;
        const numberOfLines = Math.round(height / lineHeight);

        return numberOfLines;
    }

    CheckListItemsCount(itemDescription, clampFlag) {
        if (itemDescription.localName == 'ul') {
            let listItems = itemDescription.querySelectorAll('li');

            for (var i = 0; i < listItems.length; i++) {
                if (i <= this.lineCountDifference - 1) {
                    continue;
                } else {
                    switch (clampFlag) {
                        case true:
                            listItems[i].classList.add('item-hidden');
                            break;
                        case false:
                            listItems[i].classList.remove('item-hidden');
                            break;
                        default:
                            listItems[i].classList.add('item-hidden');
                            break;
                    }
                }
            }
        }
    }
}
export default DestinationTruncation;